// extracted by mini-css-extract-plugin
module.exports = {"goods":"Order_goods__tH1X-","total":"Order_total__2MVg3","header":"Order_header__2pVFe"};